import * as React from "react";

// style, design
import BaseTable from "src/components/Lists/Base/FinalTable/BaseTable";
import { OPERATOR_TEMPLATES } from "src/components/Lists/Base/FinalTable/utils";

import columnDefs from "./listDefs";

import { constants, detailUrl } from "../../../store/leaseContracts";
import { useFrequentPermissions } from "../../../store/base";
import { useHistory } from "react-router-dom";
import { BADGE_TYPES } from "../../Badge/Badge";

export default function LeaseContractsTable({
  persistantQuery,
  isBare,
  ignoreLocalStorage,
  tableId,
  onRowClicked,
  checkRowHighlighted,
  onRowSelected,
  disableBadgeFilterCounts,
}) {
  const { hasBillectaViewPermission } = useFrequentPermissions();

  const filters = {
    Avtalsnummer: {
      queryKey: "id_number",
      type: "text",
      operators: OPERATOR_TEMPLATES.SEARCH,
    },
    Hyresgäst: {
      queryKey: "tenant_name",
      type: "text",
      operators: OPERATOR_TEMPLATES.SEARCH,
    },
    Aviseringsstatus: {
      queryKey: "lease_invoicing_active",
      type: "boolean",
      operators: OPERATOR_TEMPLATES.BOOLEAN,
    },
    Fastighet: {
      queryKey: "realestate__key",
      type: "text",
      operators: OPERATOR_TEMPLATES.SEARCH,
    },
    //Waiting for backend to add support [DEV-728]
    // Area: {
    //   queryKey: "area",
    //   type: "number",
    //   operators: OPERATOR_TEMPLATES.NUMBER,
    // },
    Startdatum: {
      queryKey: "start_date",
      type: "date",
      operators: OPERATOR_TEMPLATES.DATE,
    },
    Slutdatum: {
      queryKey: "end_date",
      type: "date",
      operators: OPERATOR_TEMPLATES.DATE,
    },
  };

  const badges = {
    Aktiva: {
      color: BADGE_TYPES.GREEN,
      querySet: {
        state__in: [0, 1, 2],
      },
    },
    Utgående: {
      color: BADGE_TYPES.YELLOW,
      querySet: {
        state__in: [3],
      },
    },
    Kommande: {
      color: BADGE_TYPES.INDIGO,
      querySet: {
        state__in: [4],
      },
    },
    "Ej signerade": {
      color: BADGE_TYPES.PURPLE,
      querySet: {
        state__in: [5],
      },
    },
    Uppsagda: {
      color: BADGE_TYPES.RED,
      querySet: {
        state__in: [6, 7],
      },
    },
    Tidigare: {
      color: BADGE_TYPES.GRAY,
      querySet: {
        state__in: [9],
      },
    },
    Hyreslägenheter: {
      color: BADGE_TYPES.CYAN,
      querySet: {
        apartments__isnull: false,
      },
    },
    Lokaler: {
      color: BADGE_TYPES.ORANGE,
      querySet: {
        industrial_premises_list__isnull: false,
      },
    },
  };

  const columns = React.useMemo(
    () => columnDefs(hasBillectaViewPermission),
    [persistantQuery, hasBillectaViewPermission]
  );

  return (
    <>
      <BaseTable
        tableId={tableId || "leasecontracts_full_table"}
        title="Hyresavtal"
        onRowClickedWithDetail={(obj) => detailUrl({ id: obj.id })}
        {...{
          isBare,
          ignoreLocalStorage,
          onRowClicked,
          columns,
          persistantQuery,
          badges,
          filters,
          constants,
          checkRowHighlighted,
          onRowSelected,
          disableBadgeFilterCounts,
        }}
      />
    </>
  );
}
